export default __webpack_public_path__ + "static/media/Labor-empty-state-icon.9020d8a1.svg";